<template>
  <div>
    <div v-for="(item, i) in prescriptionList" :key="i" class="care" @click="selectPrescrip(item)">
      <div class="patientText">
        <div v-if="[2, 3].includes(activeIndex)" class="fst_row prescripName">
          <span :class="[{ mdrug: item.prescripType === '4' }, 'name']">
            {{ item.prescripName }}
          </span>
        </div>
        <div v-if="['1', '2', '4'].includes(item.prescripType)" class="fst_row">
          <span :class="[{ mdrug: item.prescripType === '4' }, 'name']">
            {{ item.drugName }}
          </span>
        </div>
        <div v-else class="zh_wrap">
          <div
            v-for="(item2, i2) in JSON.parse(item.drugs).drugList ||
            JSON.parse(item.drugs).DrugList"
            :key="i2"
            class="zh_row"
          >
            <span class="name zh_msg"> {{ item2.drugName }} {{ item2.useAuantity }} </span>
            <span class="name zh_msg">
              {{ getKeyValueText('measure_unit', item2.measureUnit || item2.drugItem.measureUnit) }}
            </span>
            <span v-if="item2.drugDesc" class="name zh_msg">{{ '(' }}</span>
            <span v-if="item2.drugDesc" class="name zh_msg">
              {{ getKeyValueText('prescrip_desc', item2.drugDesc, ' ') || '' }}
            </span>
            <span v-if="item2.drugDesc" class="name zh_msg">{{ ')' }}</span>
            <span
              v-if="
                i2 !=
                (JSON.parse(item.drugs).drugList || JSON.parse(item.drugs).DrugList).length - 1
              "
              class="name zh_msg"
            >
              {{ '，' }}
            </span>
          </div>
        </div>
        <div v-if="[1, 2, 3].includes(activeIndex)" class="diagnose_row">
          <span class="name">诊断：</span>
          <div v-if="item.diagnosis" class="diagnosis">
            <span class="['mdrug', 'text']">
              {{ formatSymptomName(item.diagnosis ? item.diagnosis : []) }}
            </span>
          </div>
        </div>
        <div v-if="[3].includes(activeIndex)" class="diagnose_row">
          <span class="name">应用科室：</span>
          <div class="diagnosis">
            <span class="text">{{ item.deptName }}</span>
          </div>
        </div>
        <div v-if="[0, 1].includes(activeIndex)" class="create_time">
          <span class="code">开方时间：{{ item.prescripCreateTime }}</span>
        </div>
      </div>
      <div v-if="[0, 1].includes(activeIndex)" class="iconBox">
        <img
          v-if="selectPre.prescripNum === item.prescripNum"
          class="iconBoxImg"
          src="@funcPuzzle/mini_patient/patientSelection.png"
        />
        <img
          v-else
          class="iconBoxImg"
          src="@funcPuzzle/mini_patient/notSelected.png"
        />
      </div>
      <div v-if="[2, 3].includes(activeIndex)" class="iconBox">
        <img
          v-if="selectPre.prescripTemplateNum === item.prescripTemplateNum"
          class="iconBoxImg"
          src="@funcPuzzle/mini_patient/patientSelection.png"
        />
        <img
          v-else
          class="iconBoxImg"
          src="@funcPuzzle/mini_patient/notSelected.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { formatSymptomName, getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
export default {
  props: {
    prescriptionList: {
      type: [Array],
      default: () => {
        return []
      }
    },
    activeIndex: {
      type: [Object, String, Number],
      default: ''
    }
  },
  data() {
    return {
      drugData: '',
      selectPre: '',
      list: []
    }
  },
  watch: {
    activeIndex: {
      handler(val) {},
      immediate: true
    },
    prescriptionList: {
      handler(val) {
        if (val[0]) {
          this.prescriptionList.map(value => {
            const drugNameList = []

            const list = JSON.parse(value.drugs).drugList || JSON.parse(value.drugs).DrugList

            if (value.drugs && list && list[0]) {
              list.forEach(item => {
                drugNameList.push(item.drugName)
              })
              value.drugName = drugNameList.join(',')
            }
            return value
          })

          this.selectPrescrip(val[0])
        }
      },
      immediate: true
    }
  },

  methods: {
    getKeyValueText,
    formatSymptomName,
    selectPrescrip(item) {
      this.selectPre = item
      this.$emit('updateDrug', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.care {
  padding: 0.512rem 0.682667rem;
  margin: 0 auto;
  width: 100%;
  min-height: 3.328rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.021333rem solid #ececec;
  box-sizing: border-box;
  .patientText {
    // margin-top: .213333rem;
    display: flex;
    flex-direction: column;
    .zh_wrap {
      display: flex;
      width: 12.8rem;
      flex-wrap: wrap;
    }
    .fst_row,
    .zh_row {
      margin-bottom: 0.213333rem;
      display: flex;
      .name,
      .zh_msg {
        font-size: 0.64rem;
        font-weight: 400;
        color: #222222;
        display: inline-block;
        margin-right: 0.512rem;
        font-size: 0.682667rem;
        font-weight: bold;
      }
      .zh_msg {
        margin-right: 0;
      }
      .name {
        font-weight: 400 !important;
      }
    }
    .prescripName {
      .name {
        font-weight: 500 !important;
      }
    }
    .diagnose_row {
      display: flex;
      margin-bottom: 0.213333rem;
      .name,
      .text {
        min-width: 1.92rem;
        font-size: 0.64rem;
        font-weight: 400;
        color: #888888;
      }
      .text {
        color: #0089ff;
      }
    }
    .create_time {
      .code {
        font-size: 0.64rem;
        font-weight: 400;
        color: #888;
      }
    }

    .label {
      display: inline-block;
      background: #0089ff;
      color: #fff;
      font-size: 0.512rem;
      height: 0.597333rem;
      line-height: 0.597333rem;
      padding: 0.085333rem 0.213333rem;
      border-radius: 0.085333rem;
    }
  }

  .iconBox {
    width: 1.066667rem;
    height: 2.133333rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .iconBoxImg {
      width: 0.768rem;
      height: 0.768rem;
    }
  }
}
</style>
